import { API_HOST, getHttpGetOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/notification`;
const getViewAllNotificationsEndpoint = (systemUserExternalReference) =>
  `${getEndpoint()}/${systemUserExternalReference}`;
const getQueryNewNotificationsEndpoint = (systemUserExternalReference, lastNotificationUUID) =>
  `${getViewAllNotificationsEndpoint(systemUserExternalReference)}/${lastNotificationUUID}/new`;
const getViewNewNotificationsEndpoint = (systemUserExternalReference, lastNotificationUUID) =>
  `${getQueryNewNotificationsEndpoint(systemUserExternalReference, lastNotificationUUID)}/retrieve`;

export const getViewAllNotificationsRequest = (systemUserExternalReference) => [
  getViewAllNotificationsEndpoint(systemUserExternalReference),
  getHttpGetOptions()
];

export const getQueryNewNotificationsRequest = (systemUserExternalReference, lastNotificationUUID) => [
  getQueryNewNotificationsEndpoint(systemUserExternalReference, lastNotificationUUID),
  getHttpGetOptions()
];

export const getViewNewNotificationsRequest = (systemUserExternalReference, lastNotificationUUID) => [
  getViewNewNotificationsEndpoint(systemUserExternalReference, lastNotificationUUID),
  getHttpGetOptions()
];
